import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import CloseIcon from '@mui/icons-material/Close'
import {
  AppBar,
  Backdrop,
  Box,
  Card,
  CircularProgress,
  Container,
  Dialog,
  Grid,
  IconButton,
  Toolbar,
  Typography,
} from '@mui/material'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import { Dispatch } from '@reduxjs/toolkit'
import { toFarsiDigits } from 'farsi-digits'
import _ from 'lodash'
import { useSnackbar } from 'notistack'
import React, { useEffect } from 'react'
import gregorian from 'react-date-object/calendars/gregorian'
import persian from 'react-date-object/calendars/persian'
import gregorian_en from 'react-date-object/locales/gregorian_en'
import persian_fa from 'react-date-object/locales/persian_fa'
import { useTranslation } from 'react-i18next'
import { DateObject } from 'react-multi-date-picker'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'

import ABS from '../../assests/icons/abs.png'
import ACU from '../../assests/icons/acu.png'
import BCM from '../../assests/icons/bcm.png'
import Ecu from '../../assests/icons/ecu.png'
import { IsServiceItem } from '../../interfaces/IsServiceItem'
import CardErrorEngine from '../../shared/CardErrorEngine'
import ServiceItemContainerErrors from '../../shared/ServiceItemContainerErrors'
import {
  getLoading,
  getPaginatedTrouble,
  getTroublePaginated,
  resetPaginatedTrouble,
} from '../../store/devices'
interface Props {
  items: IsServiceItem[]
}
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction='up' ref={ref} {...props} />
})
const HistoryErrorsScreen = () => {
  const [open, setOpen] = React.useState(false)
  const [open1, setOpen1] = React.useState(false)
  const [open2, setOpen2] = React.useState(false)
  const [open3, setOpen3] = React.useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)

    dispatch(resetPaginatedTrouble)
  }
  const handleClickOpen1 = () => {
    setOpen1(true)
  }

  const handleClose1 = () => {
    setOpen1(false)
    dispatch(resetPaginatedTrouble)
  }
  const handleClickOpen2 = () => {
    setOpen2(true)
  }

  const handleClose2 = () => {
    setOpen2(false)
    dispatch(resetPaginatedTrouble)
  }
  const handleClickOpen3 = () => {
    setOpen3(true)
  }

  const handleClose3 = () => {
    setOpen3(false)
    dispatch(resetPaginatedTrouble)
  }
  const Services: IsServiceItem[] = [
    {
      id: '1',
      disable: false,
      title: 'ECU',
      icon: <img src={Ecu} style={{ marginTop: 4 }} width='50px' />,

      onClick: () => {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        dispatch(getPaginatedTrouble({ deviceId: id, unitType: 1 }))
        handleClickOpen()
      },
    },
    {
      id: '2',
      title: 'ABS',
      disable: true,
      icon: <img src={ABS} style={{ marginTop: 4 }} width='50px' />,

      onClick: () => {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        // dispatch(getPaginatedTrouble({ deviceId: id, unitType: 2 }))
        // handleClickOpen1()
      },
    },
    {
      id: '3',
      title: 'ACU',
      disable: true,
      icon: <img src={ACU} style={{ marginTop: 4 }} width='50px' />,

      onClick: () => {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        // dispatch(getPaginatedTrouble({ deviceId: id, unitType: 3 }))
        // handleClickOpen2()
      },
    },
    {
      id: '4',
      disable: true,
      title: 'BCM',
      icon: <img src={BCM} style={{ marginTop: 4 }} width='50px' />,

      onClick: () => {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        // dispatch(getPaginatedTrouble({ deviceId: id, unitType: 4 }))
        // handleClickOpen3()
      },
    },
  ]
  const { id } = useParams()
  const { t } = useTranslation()
  const loading = useSelector(getLoading)

  const dispatch = useDispatch<Dispatch<any>>()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const TroublePaginated = useSelector(getTroublePaginated)

  useEffect(() => {
    return () => {
      dispatch(resetPaginatedTrouble)
    }
  }, [])
  // useEffect(() => {
  //   if (id !== undefined) dispatch(getPaginatedTrouble({ deviceId: id }))
  // }, [])
  // تابع تبدیل تاریخ شمسی به میلادی
  const shamsi = (time: any) => {
    const time1 = time
    const replaceTime = _.replace(time1, 'T', ' ')

    const date = new DateObject({
      date: replaceTime,
      format: 'YYYY/MM/DD HH:mm:ss',
    })
    date.convert(persian, persian_fa)
    date.add(3, 'hour')
    date.add(30, 'minute')
    return date.format('HH:mm:ss YYYY/MM/DD')
  }
  return (
    <Container fixed maxWidth='sm'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          direction: 'ltr',
        }}
      >
        <Box display='grid' gridTemplateColumns='auto auto' sx={{ mt: 2, mb: 2, direction: 'ltr' }}>
          <ArrowBackRoundedIcon
            onClick={() => navigate(-1)}
            sx={{
              backgroundColor: 'red',
              borderRadius: '50%',
              color: '#fff',
              cursor: 'pointer',
            }}
          />
          <img alt='Logo' src='/images/TinyLogo.png' />
        </Box>
        <Box display='flex' justifyContent='center'>
          <Card
            sx={{
              width: { xs: 1, sm: 1, md: 1, lg: 1 },
              m: 2,
              p: 1,
              display: 'flex',
              justifyContent: 'center',
              background: 'gray',
            }}
          >
            <Typography>تاریخچه خطاها</Typography>
          </Card>
        </Box>

        <ServiceItemContainerErrors items={Services} />
        <div>
          <Dialog
            fullScreen
            onClose={handleClose}
            open={open}
            sx={{ zIndex: '10000000000' }}
            TransitionComponent={Transition}
          >
            <Backdrop
              open={loading}
              sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 10000000000000000000000000000000000000,
                position: 'absolute',
              }}
            >
              <div className='progress1'></div>
            </Backdrop>
            <AppBar sx={{ position: 'sticky' }}>
              <Toolbar>
                <IconButton aria-label='close' color='inherit' edge='start' onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
                <Typography component='div' sx={{ ml: 2, flex: 1, direction: 'ltr' }} variant='h6'>
                  ECU تاریخچه
                </Typography>
                <Typography component='div' sx={{ ml: 2, flex: 1, textAlign: 'end' }} variant='h6'>
                  {TroublePaginated?.data !== undefined && (
                    <>تعداد خطا:{toFarsiDigits(TroublePaginated?.data?.length)}</>
                  )}
                </Typography>
              </Toolbar>
            </AppBar>
            {TroublePaginated?.data?.length !== 0 ? (
              <Box sx={{ direction: 'rtl' }}>
                {TroublePaginated?.data?.map((device: any, index: number) => (
                  <CardErrorEngine
                    date={shamsi(device.creationDate)}
                    index={index + 1}
                    key={device.id}
                    title={device.code}
                    type={device.troubleDataDescription}
                  >
                    <Box alignItems='center' display='flex'>
                      <Typography component={'span'} sx={{ m: 1 }}>
                        {t('screens.ErrorEngineScreen.Description')}
                      </Typography>
                      <Typography>{device.troubleCodeDescription.description}</Typography>
                    </Box>
                  </CardErrorEngine>
                ))}
              </Box>
            ) : (
              <Box display='flex' justifyContent='center'>
                <Card
                  sx={{
                    width: { xs: 1, sm: 1, md: 2 / 4, lg: 2 / 4 },
                    m: 2,
                    p: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    background: 'gray',
                  }}
                >
                  <Typography>{t('screens.ErrorEngineScreen.no_errors')}</Typography>
                </Card>
              </Box>
            )}
          </Dialog>
        </div>
        <div>
          <Dialog
            fullScreen
            onClose={handleClose1}
            open={open1}
            sx={{ zIndex: '10000000000000' }}
            TransitionComponent={Transition}
          >
            <Backdrop
              open={loading}
              sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 10000000000000000000000000000000000000,
                position: 'absolute',
              }}
            >
              <div className='progress1'></div>
            </Backdrop>
            <AppBar sx={{ position: 'sticky' }}>
              <Toolbar>
                <IconButton aria-label='close' color='inherit' edge='start' onClick={handleClose1}>
                  <CloseIcon />
                </IconButton>
                <Typography component='div' sx={{ ml: 2, flex: 1, direction: 'ltr' }} variant='h6'>
                  ABS تاریخچه
                </Typography>
                <Typography component='div' sx={{ ml: 2, flex: 1, textAlign: 'end' }} variant='h6'>
                  {TroublePaginated?.data !== undefined && (
                    <>تعداد خطا:{toFarsiDigits(TroublePaginated?.data?.length)}</>
                  )}
                </Typography>
              </Toolbar>
            </AppBar>
            {TroublePaginated?.data?.length !== 0 ? (
              <Box sx={{ direction: 'rtl' }}>
                {TroublePaginated?.data?.map((device: any, index: number) => (
                  <CardErrorEngine
                    date={shamsi(device.creationDate)}
                    index={index + 1}
                    key={device.id}
                    title={device.code}
                    type={device.troubleDataDescription}
                  >
                    <Box alignItems='center' display='flex'>
                      <Typography component={'span'} sx={{ m: 1 }}>
                        {t('screens.ErrorEngineScreen.Description')}
                      </Typography>
                      <Typography>{device.troubleCodeDescription.description}</Typography>
                    </Box>
                  </CardErrorEngine>
                ))}
              </Box>
            ) : (
              <Box display='flex' justifyContent='center'>
                <Card
                  sx={{
                    width: { xs: 1, sm: 1, md: 2 / 4, lg: 2 / 4 },
                    m: 2,
                    p: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    background: 'gray',
                  }}
                >
                  <Typography>{t('screens.ErrorEngineScreen.no_errors')}</Typography>
                </Card>
              </Box>
            )}
          </Dialog>
        </div>
        <div>
          <Dialog
            fullScreen
            onClose={handleClose2}
            open={open2}
            sx={{ zIndex: '10000000000000' }}
            TransitionComponent={Transition}
          >
            <Backdrop
              open={loading}
              sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 10000000000000000000000000000000000000,
                position: 'absolute',
              }}
            >
              <div className='progress1'></div>
            </Backdrop>
            <AppBar sx={{ position: 'sticky' }}>
              <Toolbar>
                <IconButton aria-label='close' color='inherit' edge='start' onClick={handleClose2}>
                  <CloseIcon />
                </IconButton>
                <Typography component='div' sx={{ ml: 2, flex: 1, direction: 'ltr' }} variant='h6'>
                  ACU تاریخچه
                </Typography>
                <Typography component='div' sx={{ ml: 2, flex: 1, textAlign: 'end' }} variant='h6'>
                  {TroublePaginated?.data !== undefined && (
                    <>تعداد خطا:{toFarsiDigits(TroublePaginated?.data?.length)}</>
                  )}
                </Typography>
              </Toolbar>
            </AppBar>
            {TroublePaginated?.data?.length !== 0 ? (
              <Box sx={{ direction: 'rtl' }}>
                {TroublePaginated.data?.map((device: any, index: number) => (
                  <CardErrorEngine
                    date={shamsi(device.creationDate)}
                    index={index + 1}
                    key={device.id}
                    title={device.code}
                    type={device.troubleDataDescription}
                  >
                    <Box alignItems='center' display='flex'>
                      <Typography component={'span'} sx={{ m: 1 }}>
                        {t('screens.ErrorEngineScreen.Description')}
                      </Typography>
                      <Typography>{device.troubleCodeDescription.description}</Typography>
                    </Box>
                  </CardErrorEngine>
                ))}
              </Box>
            ) : (
              <Box display='flex' justifyContent='center'>
                <Card
                  sx={{
                    width: { xs: 1, sm: 1, md: 2 / 4, lg: 2 / 4 },
                    m: 2,
                    p: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    background: 'gray',
                  }}
                >
                  <Typography>{t('screens.ErrorEngineScreen.no_errors')}</Typography>
                </Card>
              </Box>
            )}
          </Dialog>
        </div>
        <div>
          <Dialog
            fullScreen
            onClose={handleClose3}
            open={open3}
            sx={{ zIndex: '10000000000' }}
            TransitionComponent={Transition}
          >
            <Backdrop
              open={loading}
              sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 10000000000000000000000000000000000000,
                position: 'absolute',
              }}
            >
              <div className='progress1'></div>
            </Backdrop>
            <AppBar sx={{ position: 'sticky' }}>
              <Toolbar>
                <IconButton aria-label='close' color='inherit' edge='start' onClick={handleClose3}>
                  <CloseIcon />
                </IconButton>
                <Typography component='div' sx={{ ml: 2, flex: 1, direction: 'ltr' }} variant='h6'>
                  BCM تاریخچه
                </Typography>
                <Typography component='div' sx={{ ml: 2, flex: 1, textAlign: 'end' }} variant='h6'>
                  {TroublePaginated?.data !== undefined && (
                    <>تعداد خطا:{toFarsiDigits(TroublePaginated?.data?.length)}</>
                  )}
                </Typography>
              </Toolbar>
            </AppBar>
            {TroublePaginated?.data?.length !== 0 ? (
              <Box sx={{ direction: 'rtl' }}>
                {TroublePaginated?.data?.map((device: any, index: number) => (
                  <CardErrorEngine
                    date={shamsi(device.creationDate)}
                    index={index + 1}
                    key={device.id}
                    title={device.code}
                    type={device.troubleDataDescription}
                  >
                    <Box alignItems='center' display='flex'>
                      <Typography component={'span'} sx={{ m: 1 }}>
                        {t('screens.ErrorEngineScreen.Description')}
                      </Typography>
                      <Typography>{device.troubleCodeDescription.description}</Typography>
                    </Box>
                  </CardErrorEngine>
                ))}
              </Box>
            ) : (
              <Box display='flex' justifyContent='center'>
                <Card
                  sx={{
                    width: { xs: 1, sm: 1, md: 2 / 4, lg: 2 / 4 },
                    m: 2,
                    p: 1,
                    display: 'flex',
                    justifyContent: 'center',
                    background: 'gray',
                  }}
                >
                  <Typography>{t('screens.ErrorEngineScreen.no_errors')}</Typography>
                </Card>
              </Box>
            )}
          </Dialog>
        </div>
        {/* <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: '85vh',
            overflowY: 'auto',
          }}
        >
          {TroublePaginated?.data?.length !== 0 ? (
            <Box sx={{ maxHeight: '85vh', direction: 'rtl' }}>
              {TroublePaginated?.data?.map((device: any, index: number) => (
                <Grid item key={device.id} lg={3} md={4} sm={6} xs={12}>
                  <CardErrorEngine
                    date={shamsi(device.creationDate)}
                    index={index + 1}
                    title={device.code}
                  >
                    <Box display='flex' justifyContent='space-between'>
                      <Typography>{t('screens.HistoryErrorsScreen.Description')}</Typography>
                      <Typography>{device.troubleCodeDescription.description}</Typography>
                    </Box>
                  </CardErrorEngine>
                </Grid>
              ))}
            </Box>
          ) : (
            <Card sx={{ p: 1, display: 'flex', justifyContent: 'center' }}>
              <Typography>{t('screens.HistoryErrorsScreen.no_info')}</Typography>
            </Card>
          )}
        </Box> */}
      </Box>
    </Container>
  )
}

export default HistoryErrorsScreen
